import React, { useMemo, useState } from 'react'

import * as S from './styles'
import { ButtonIcon, Text } from '..'
import { CloseIcon, DarkListIcon, ListIcon } from '@/assets/icons'

type MobileMenuOption = {
  text: string
  onClick: () => void
}

export type MobileMenuProps = {
  /**
   * Options of the menu
   *
   * @example
   * ```tsx
   * <MobileMenu options={[{ text: 'Opção 1', onClick: () => null }]} />
   * ```
   *
   */
  options: MobileMenuOption[]

  /**
   * Class name of the button
   *
   * @example
   * ```tsx
   * <MobileMenu className="button-icon" />
   * ```
   *
   */
  iconClassName?: string

  /**
   * Dark Mode
   *
   * @example
   * ```tsx
   * <MobileMenu darkmode=true />
   * ```
   *
   */
  darkMode?: boolean
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
  options,
  iconClassName,
  darkMode,
}) => {
  const [open, setOpen] = useState(false)
  const icon = useMemo(() => {
    if (darkMode) {
      return open ? CloseIcon : ListIcon
    }
    return open ? CloseIcon : DarkListIcon
  }, [open, darkMode])

  return (
    <S.Container>
      <ButtonIcon
        icon={icon}
        alt="Botão para abrir e fechar o menu"
        onClick={() => setOpen(!open)}
        className={iconClassName}
      />
      {open && (
        <S.Menu>
          {options.map((option) => (
            <Text
              key={option.text}
              size="b1"
              color="primary"
              onClick={option.onClick}
            >
              {option.text}
            </Text>
          ))}
        </S.Menu>
      )}
    </S.Container>
  )
}
